const downloadBase = (version, filename) => `${process.env.PUBLIC_URL}/downloads/${version}/${filename}`;

export const downloadProgramName = 'Data Preprocessing App';

export const downloadVersions = [
	{
		version: '0.1.0',
		releaseDate: '2026-08-04',
		files: {
			installer: {
				label: `${downloadProgramName} Installer`,
				type: 'installer',
				path: downloadBase('0.1.0', 'installer.msi'),
			},
			installGuide: {
				label: 'Installation Guide (PDF)',
				type: 'pdf',
				path: downloadBase('0.1.0', 'install-guide.pdf'),
			},
			userManual: {
				label: 'User Manual (PDF)',
				type: 'pdf',
				path: downloadBase('0.1.0', 'user-manual.pdf'),
			},
		},
	},
];

export const getLatestDownloadVersion = () => downloadVersions[downloadVersions.length - 1];
